<template>
  <div class="py-4">
    <v-form v-model="valid" class="pa-2 my-2" ref="bankAccountForm">
      <v-row>
        <v-col cols="6" sm="7" class="py-1">
          <div
            v-if="showNoValidPeriodText"
            class="text-body-1 font-weight-medium"
          >
            <v-card-text class="text-subtitle-1">
              {{
                $t(
                  "components.registration_completion_sba.stepOptOuts_not_valid_period"
                )
              }}
            </v-card-text>
          </div>
          <v-list v-else subheader>
            <v-list-item-group multiple>
              <template v-for="(group, index) in coverageGroups">
                <v-list-item :key="group.Id">
                  <v-list-action>
                    <v-checkbox
                      :label="'I would like to opt out from ' + group.Name"
                      :input-value="
                        coverageGroupsSelected.some((x) => x.Id === group.Id)
                      "
                      @change="
                        selectCoverageGroup(group.Id, group.Name, $event)
                      "
                    />
                  </v-list-action>
                </v-list-item>
                <v-divider
                  v-if="index < coverageGroups.length - 1"
                  :key="`divider-${index}`"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {
    saving: Boolean,
    memberBankAccount: Object,
  },
  data() {
    return {
      optOutOption: {},
      dateMenu: false,
      internalBankAccount: {},
      optOutOptions: [
        { value: 1, label: "Completely Opt-Out" },
        { value: 2, label: "Partially Opt-Out or Just Register" },
      ],
      coverageGroupsSelected: [],
      coverageGroups: [],
      valid: false,
      editMode: false,
      errorMessage: "",
      confirmBankAccountDialog: "",
      noValidPeriodText: "",
      showNoValidPeriodText: false,
      validating: false,
      authorize: false,
      headersDictionary: {},
    };
  },
  async mounted() {
    this.getCoverageGroups(this.user.plan);
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  watch: {
    coverageGroups: {
      handler(v) {
        this.$emit("save-coverage-groups", v);
      },
      deep: true,
    },
    optOutOption: {
      handler(v) {
        if (v.value === 1) {
          this.$emit("opt-out-option", v);
        } else {
          this.$emit("opt-out-option", v);
        }
      },
      deep: true,
    },
    coverageGroupsSelected: {
      handler(v) {
        this.$emit("coverage-groups-selected", v);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("data", [
      "validateBankAccount",
      "getMemberAvailableCoverageGroups",
      "getOptOutValidPeriod",
    ]),
    async saveMember() {
      if (this.coverageGroupsSelected.length < this.coverageGroups.length) {
        this.optOutOption.value = 2;
      } else {
        this.optOutOption.value = 1;
      }
    },
    async getCoverageGroups() {
      const response = await this.getMemberAvailableCoverageGroups({
        planId: this.user.plan,
        certificate: this.user.gatewayMemberId,
      });
      const periodResponse = await this.getOptOutValidPeriod({
        certificate: this.user.gatewayMemberId,
        planId: this.user.plan,
      });
      if (periodResponse.data.Response === null) {
        this.activeNoValidPeriodText();
      }
      const availableGroups = response.data.Response;
      const optOutGroups = periodResponse.data.Response.CoverageGroups;
      this.coverageGroups = availableGroups.map((group) => {
        const optOutGroup = optOutGroups.find((og) => og.Id === group.Id);
        return {
          ...group,
          isProofRequired: optOutGroup ? optOutGroup.isProofRequired : false,
        };
      });
    },
    activeNoValidPeriodText() {
      this.showNoValidPeriodText = true;
      return;
    },
    selectCoverageGroup(coverageGroupId, name, value) {
      if (value) {
        if (
          !this.coverageGroupsSelected.find((x) => x.Id === coverageGroupId)
        ) {
          const newGroup = {
            Id: coverageGroupId,
            Name: name,
            Proof: null,
          };
          this.coverageGroupsSelected.push(newGroup);
        }
      } else {
        this.coverageGroupsSelected = this.coverageGroupsSelected.filter(
          (x) => x.Id !== coverageGroupId
        );
      }
      this.$emit("update-coverages", this.coverageGroupsSelected);
    },
    isBankAccountRequired() {
      const bankAccountIsMandatory =
        this.headersDictionary["Institution Number"]?.IsOptional === false &&
        this.headersDictionary["Account Number"]?.IsOptional === false &&
        this.headersDictionary["Transit Number"]?.IsOptional === false;
      if (bankAccountIsMandatory) {
        return true;
      }
      for (let key of Object.keys(this.internalBankAccount)) {
        if (
          this.internalBankAccount[key] === null ||
          this.internalBankAccount[key] === "" ||
          this.internalBankAccount[key] === undefined ||
          this.internalBankAccount[key] === false
        ) {
          delete this.internalBankAccount[key];
        }
      }
      if (Object.keys(this.internalBankAccount).length === 0) {
        if (this.$refs.bankAccountForm) {
          this.$refs.bankAccountForm.resetValidation();
        }
        this.$emit("update-valid", true);
        return false;
      }
      if (!this.valid) this.$emit("update-valid", false);
      return true;
    },
    createSections(headers) {
      for (const header of headers) {
        this.headersDictionary[header.Text] = header;
      }
    },
    getRequiredClass(fieldName) {
      return this.isBankAccountRequired()
        ? this.headersDictionary[fieldName].IsOptional === false
          ? "required"
          : []
        : "";
    },
  },
};
</script>
<style scoped>
.v-input--is-disabled >>> input {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600 !important;
}
.v-input--is-disabled >>> label {
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-input--is-disabled >>> .v-select__selection {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600 !important;
}
.v-input--selection-controls__ripple {
  margin-right: 0px !important;
}
.v-tooltip__content {
  max-width: 150px !important;
}
.note {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}
.note > .v-input--selection-controls {
  margin-top: 0;
}
</style>
